class ShopByFabricModalTrigger extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('.shop-by-fabric__jumplink-modal-button');

      if (!trigger) return;

      trigger.dispatchEvent(new CustomEvent('markup-modal:open', { bubbles: true, detail: { target: this.modalId, html: this.fabricsMarkup } }));
    });
  }

  connectedCallback() {
  }

  disconnectedCallback() {

  }

  get fabricsMarkup() {
    return this.fabrics.map(({ id, title }) => `
    <li class="shop-by-fabric-modal__item">
      <a class="shop-by-fabric-modal__jumplink" href="#${id}">${title}</a>
    </li>`)
      .join('');
  }

  get fabrics() {
    return [...this.closest('.shopify-section').querySelectorAll('[data-fabric-item]')].map(item => ({
      id: item.id,
      title: item.querySelector('[data-fabric-item-title]').innerHTML,
    }));
  }

  get modalId() {
    return this.getAttribute('modal-id');
  }
}

if (!customElements.get("shop-by-fabric-modal-trigger")) {
  customElements.define("shop-by-fabric-modal-trigger", ShopByFabricModalTrigger);
}
